import React, {useState, useEffect, useRef} from 'react';
import { CTAButtonWrapper, CTAOfferButton } from '../../../../common/styled-components/styled-components';
import { CTAPrimaryButton } from '../../../../../../app/js/components/loggedout/shared-styles/CTAPrimaryButton';
import { deepCoveDark } from '../../../../../../app/js/components/loggedout/shared-styles/Colors';

import { Link } from 'react-router-dom';
import Routes from '../../../../routes/routes';
import * as S from './style';
import Filters from './filter';
import Card from './cards'
import GradeWave from '~images/sem/grade-wave.png';
import Image from '../../../../../../app/js/components/loggedout/common/Image';
import {gradesAndContentGroup, grades} from './data';

const GradeContent = ({trackPromoPageEvents, settings}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [gradesAndCgData, setGradesAndCgData] = useState(gradesAndContentGroup);
  const [selectedGrade, selectGradeHandler] = useState('pk');
  
  const filterHandler = ({index, gradeId}) => {
    setActiveIndex(index);
    selectGradeHandler(gradeId);
  }
  let ctaText = settings.trial_days ? `Try for free` : 'Subscribe Now';  
  return (
    <S.ContainerWrapper>
      <S.WaveWrapper>
        <Image src={GradeWave}/>
      </S.WaveWrapper>
      <S.HeadingText>Practice & Master all PreK-5 skills</S.HeadingText>
      <S.SubHeadingText>Through 4,000+ Math and Reading games</S.SubHeadingText>
      <Filters gradeMap={grades} activeIndex={activeIndex} filterHandler={filterHandler}/>
      <S.CardWrapper>
        {
          gradesAndCgData[selectedGrade].map((course)=>
            <Card 
              course={Object.keys(course)}
              subjectMap={course}
              contentGroupIdMap={gradesAndCgData}
            />
          )
        }
      </S.CardWrapper>
      <S.ButtonWrapper>
        <CTAOfferButton white={true} textColor={deepCoveDark} fontWeight="600" hoverColor="rgb(237, 237, 249)">
        <Link to={Routes.PURCHASE_ROUTE} onClick={()=>trackPromoPageEvents("Promo Page Interacted", {'clicked_on' : 'CTA3'}, true)}>
            {ctaText}
        </Link>
        </CTAOfferButton>
      </S.ButtonWrapper>
    </S.ContainerWrapper>
  )
}
export default GradeContent;